import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface NavItemProps {
  to: string;
  label: string;
  icon: string;
}

function NavItem({ to, label, icon }: NavItemProps) {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '8px 16px',
        borderRadius: '8px',
        textDecoration: 'none',
        fontSize: '13px',
        fontFamily: 'var(--font-sans)',
        fontWeight: 500,
        color: isActive ? 'var(--text-primary)' : 'var(--text-secondary)',
        background: isActive ? 'var(--bg-elevated)' : 'transparent',
        borderLeft: isActive ? '2px solid var(--accent)' : '2px solid transparent',
        transition: 'all 0.15s ease',
        marginLeft: '8px',
        marginRight: '8px',
      })}
    >
      <span style={{ fontSize: '14px' }}>{icon}</span>
      {label}
    </NavLink>
  );
}

function SectionLabel({ label }: { label: string }) {
  return (
    <div style={{
      padding: '16px 24px 6px',
      fontSize: '10px',
      fontWeight: 600,
      letterSpacing: '0.08em',
      color: 'var(--text-disabled)',
      fontFamily: 'var(--font-sans)',
      textTransform: 'uppercase',
    }}>
      {label}
    </div>
  );
}

function Divider() {
  return (
    <div style={{
      height: '1px',
      background: 'var(--border-subtle)',
      margin: '8px 0',
    }} />
  );
}

export function Sidebar() {
  const { user, logout } = useAuth();

  return (
    <aside style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: 'var(--sidebar-w)',
      height: '100vh',
      background: 'var(--bg-secondary)',
      borderRight: '1px solid var(--border-subtle)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      zIndex: 100,
    }}>
      {/* Logo */}
      <div style={{ padding: '20px 24px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '28px',
            height: '28px',
            borderRadius: '6px',
            background: 'var(--accent)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 700,
            color: '#0a0a0b',
            fontFamily: 'var(--font-mono)',
            flexShrink: 0,
          }}>
            LF
          </div>
          <div>
            <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--text-primary)' }}>
              La Fontana
            </div>
            <div style={{ fontSize: '10px', color: 'var(--text-tertiary)' }}>
              Cidadania
            </div>
          </div>
        </div>
      </div>

      <Divider />

      {/* Navigation */}
      <nav style={{ flex: 1, overflowY: 'auto', paddingBottom: '8px' }}>
        <SectionLabel label="Visão Geral" />
        <NavItem to="/" label="Overview" icon="◉" />

        <Divider />
        <SectionLabel label="Marketing" />
        <NavItem to="/meta-ads" label="Meta Ads" icon="◈" />
        <NavItem to="/google-ads" label="Google Ads" icon="◈" />

        <Divider />
        <SectionLabel label="CRM" />
        <NavItem to="/kommo" label="Kommo" icon="◈" />

        <Divider />
        <SectionLabel label="Configurações" />
        <NavItem to="/campaign-tags" label="Campaign Tags" icon="⚙" />
        <NavItem to="/financeiro" label="Financeiro" icon="$" />
      </nav>

      <Divider />

      {/* User + Logout */}
      <div style={{ padding: '12px 16px' }}>
        {user && (
          <div style={{
            fontSize: '11px',
            color: 'var(--text-tertiary)',
            marginBottom: '8px',
            paddingLeft: '8px',
          }}>
            {user.name}
          </div>
        )}
        <button
          onClick={logout}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            width: '100%',
            padding: '8px 16px',
            borderRadius: '8px',
            border: 'none',
            background: 'transparent',
            color: 'var(--text-tertiary)',
            fontSize: '13px',
            fontFamily: 'var(--font-sans)',
            cursor: 'pointer',
            textAlign: 'left',
            transition: 'all 0.15s ease',
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLButtonElement).style.background = 'var(--bg-elevated)';
            (e.currentTarget as HTMLButtonElement).style.color = 'var(--red)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
            (e.currentTarget as HTMLButtonElement).style.color = 'var(--text-tertiary)';
          }}
        >
          ← Sair
        </button>
      </div>
    </aside>
  );
}
